import React, { useState, useEffect } from "react";
import "./Carousel.css";

const CarouselService = ({ carouselRow1, carouselRow2, carouselRow3, serviceName }) => {
  const rows = [carouselRow1 || [], carouselRow2 || [], carouselRow3 || []];
  const activeRows = rows.filter(r => r && r.length > 0);

  const [currentIndexes, setCurrentIndexes] = useState([0, 0, 0]);
  const [itemsPerRow, setItemsPerRow] = useState([7, 6, 7]);
  const GAP_PX = 12;

  // Adjust item count per screen size
  useEffect(() => {
    const updateItems = () => {
      const w = window.innerWidth;
      if (w <= 480) setItemsPerRow([3, 2, 3]);
      else if (w <= 767) setItemsPerRow([3, 2, 3]);
      else if (w <= 1023) setItemsPerRow([4, 3, 4]);
      else if (w <= 1439) setItemsPerRow([6, 5, 6]);
      else setItemsPerRow([7, 6, 7]);
    };
    updateItems();
    window.addEventListener("resize", updateItems);
    return () => window.removeEventListener("resize", updateItems);
  }, []);


  const directionPattern = [1, -1, 1]; // 1 = forward, -1 = backward

  const speeds = [8500, 6500, 9500];

  useEffect(() => {
    const timers = activeRows.map((row, idx) => {
      const dir = directionPattern[idx] || 1;
      const speed = speeds[idx] || 9000;
      return setInterval(() => {
        setCurrentIndexes(prev => {
          const next = [...prev];
          const len = row.length;
          if (len > 0) {
            next[idx] = (next[idx] + dir + len) % len;
          }
          return next;
        });
      }, speed);
    });
    return () => timers.forEach(t => clearInterval(t));
  }, [carouselRow1, carouselRow2, carouselRow3, itemsPerRow]);

  const moveSlide = (i, dir) => {
    const row = activeRows[i];
    if (!row || row.length === 0) return;
    setCurrentIndexes(prev => {
      const next = [...prev];
      const len = row.length;
      next[i] = (next[i] + dir + len) % len;
      return next;
    });
  };

  const renderCarouselRow = (row, i) => {
    if (!row || row.length === 0) return null;

    const visibleCount = itemsPerRow[i] || 4;
    const minRequired = Math.max(visibleCount * 2, row.length);
    const duplicatedRow = Array.from({ length: minRequired }, (_, k) => row[k % row.length]);

    const current = currentIndexes[i] || 0;
    const visible = [];
    for (let k = 0; k < visibleCount; k++) {
      visible.push(duplicatedRow[(current + k) % duplicatedRow.length]);
    }

    const flexBasis = `calc(${100 / visibleCount}% - ${GAP_PX - (GAP_PX / visibleCount)}px)`;

    return (
      <div className="carousel-wrapper" key={i}>
        <div className="carousel">
          <button className="carousel-btn left" onClick={() => moveSlide(i, -1)}>❮</button>
          <div className="carousel-slide" style={{ gap: `${GAP_PX}px` }}>
            {visible.map((img, idx) => (
              <img
                key={idx}
                src={`https://apiv2.iklimdigitals.com/uploads/${img}`}
                alt={`carousel-${i}-${idx}`}
                className="carousel-image"
                style={{ flex: `0 0 ${flexBasis}`, maxWidth: flexBasis }}
                draggable={false}
                loading="lazy"
              />
            ))}
          </div>
          <button className="carousel-btn right" onClick={() => moveSlide(i, 1)}>❯</button>
        </div>

        <div className="carousel-dots">
          {row.map((_, dotIdx) => (
            <span
              key={dotIdx}
              className={`dot ${dotIdx === (current % row.length) ? "active" : ""}`}
              onClick={() =>
                setCurrentIndexes(prev => {
                  const next = [...prev];
                  next[i] = dotIdx;
                  return next;
                })
              }
            />
          ))}
        </div>
      </div>
    );
  };

  if (activeRows.length === 0) return null;

  return (
    <div className="carousel-container">
      <h3 className="carousel-title">Some of our {serviceName} work</h3>
      {activeRows.map((row, i) => renderCarouselRow(row, i))}
    </div>
  );
};

export default CarouselService;
